<template>
    <div
        class="custom-radio-item cpointer"
        :class="{ selected: modelValue === data.value }"
        @click="change"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {};
    },
    methods: {
        change() {
            this.$emit('update:modelValue', this.data.value);
        },
    },
};
</script>
